import React, { useState, useEffect } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { AiOutlineUserDelete } from "react-icons/ai";
import IconButton from "@mui/material/IconButton";
import { Dialog, Transition } from '@headlessui/react';
import { Fragment } from 'react';
import { FaRegCheckCircle, FaRegTimesCircle } from "react-icons/fa";
import { useToast } from "../../components/ui/ToastContext";
import { jwtDecode } from 'jwt-decode';
import { BsDash } from "react-icons/bs";
import dayjs from "dayjs";
import { BsSearch } from "react-icons/bs";
import OptimizedUserList from "../../components/ui/OptimizedUserList";
import { API_URL } from "../../config";
import { useNavigate } from "react-router-dom";

function DashboardCard20physicians() {
  const navigate = useNavigate();

  const location = useLocation();
  const { item: initialData } = location.state || {};
  const [selectedEditRowData, setSelectedEditRowData] = useState(initialData);
  const [data, setData] = useState([]);
  const [userinstData, setUserinstData] = useState([]);
  const [city, setCity] = useState([]);
  const [instcity, setinstCity] = useState([]);
  const [searchQuery1, setSearchQuery1] = useState('');
  const [user, setUser] = useState(null);
  const [selecteduser1, setSelecteduser1] = useState(null);
  const [selectedInstitutionId, setSelectedInstitutionId] = useState(null);
  const [showGrid, setShowGrid] = useState(true);
  const token = localStorage.getItem('jwtToken');
  const [itemsPerPage, setItemsPerPage] = useState(5);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowGrid(false); // După 1 secundă, comutăm pe grid
    }, 1000);

    // Cleanup pentru timer
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const token = localStorage.getItem('jwtToken');
    if (token) {
      try {
        const decoded = jwtDecode(token);  // decoded is the correct variable here
        setUser(decoded); // Store decoded user data
        console.log(user)
      } catch (error) {
        console.error('Error decoding the token:', error);
      }
    }
  }, []);

  useEffect(() => {
    axios
      .get(`${API_URL}/api/physiciansinstitute`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {

        const val = response.data.filter((i) => i.inst === selectedEditRowData.description);
        setUserinstData(val);
        if (val) {
          axios
            .get(`${API_URL}/api/physician`, {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            })
            .then((response) => {
              const val1 = val.map((i) => i.physician_id)
              const users = response.data.filter((item) =>
                val1.includes(item.physician_id)
              );

              setData(users);
            })
            .catch((error) => {
              console.error("Error fetching users data:", error);
            });
        }
      })
      .catch((error) => {
        console.error("Error fetching user data:", error);

      });
  }, [selectedEditRowData]);

  useEffect(() => {
    axios
      .get(`${API_URL}/api/adressinstitutions`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setinstCity(response.data)
      })
      .catch((error) => {
        console.error("Error fetching user data:", error);

      });
  }, []);

  useEffect(() => {
    axios
      .get(`${API_URL}/api/adress`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setCity(response.data)
      })
      .catch((error) => {
        console.error("Error fetching user data:", error);

      });
  }, []);

  useEffect(() => {
    if (selecteduser1) {
      handleEditRows(selecteduser1)
    }
  }, [selecteduser1]);

  const uniqueUsers = data.filter((user) => {
    const matchesSpec = userinstData.some((spec) =>
      spec.physician_id === user.physician_id &&
      spec.spec.toLowerCase().includes(searchQuery1.toLowerCase())
    );

    const matchesInst = userinstData.some((spec) =>
      spec.physician_id === user.physician_id &&
      spec.inst.toLowerCase().includes(searchQuery1.toLowerCase())
    );

    return (
      user.user_name_surname.toLowerCase().includes(searchQuery1.toLowerCase())
      || matchesSpec
      || matchesInst
    );
  });

  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(uniqueUsers.length / itemsPerPage);
  const currentItems = uniqueUsers.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  useEffect(() => {
    setCurrentPage(1);
  }, [itemsPerPage]);

  const handleEditRows = (item) => {
    navigate("/physicians/editphysician", { state: { item } });
  };

  return (
    <div>
      {showGrid ? (
        <div className="flex flex-row gap-2">
          <div className="animate-pulse bg-gray-300 w-14 h-14 rounded-lg"></div>
          <div className="flex flex-col gap-2">
            <div className="animate-pulse bg-gray-300 w-28 h-5 rounded-lg"></div>
            <div className="animate-pulse bg-gray-300 w-36 h-3 rounded-lg"></div>
            <div className="animate-pulse bg-gray-300 w-36 h-2 rounded-lg"></div>
          </div>
        </div>
      ) : (
        <div className="col-span-full xl:col-span-8 bg-white dark:bg-gray-800 shadow-sm rounded-xl ">
          <header className="px-5 py-4 border-b border-gray-100 dark:border-gray-700/60 flex justify-between items-center">
            <h2 className="font-semibold text-gray-800 dark:text-gray-100">Doctorii activi in cadrul institutiei</h2>
            <div className="sm:flex sm:items-center sm:gap-4 w-full sm:w-auto">

              <div className="relative w-full sm:w-64 md:w-80">
                <BsSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                <input
                  type="text"
                  className="pl-10 w-full rounded-md border border-gray-300 bg-white px-3 py-2 focus:border-blue-500 focus:outline-none dark:bg-gray-800 dark:text-gray-200"
                  placeholder="Căutare doctor"
                  value={searchQuery1}
                  onChange={(e) => setSearchQuery1(e.target.value)} />
              </div>
            </div>
          </header>

          {uniqueUsers.length > 0 ? (
            <div className="p-3" >
              <div className="overflow-x-auto">
                <table className="table-auto w-full dark:text-gray-300">
                  <thead className="text-xs uppercase text-gray-400 dark:text-gray-500 bg-gray-100 dark:bg-gray-700 dark:bg-opacity-50 rounded-sm">
                    <tr>
                      <th className="p-2">
                        <div className="font-semibold text-left">Nume Prenume</div>
                      </th>
                      <th className="p-2">
                        <div className="font-semibold text-center">Email</div>
                      </th>
                      <th className="p-2">
                        <div className="font-semibold text-center">Telefon</div>
                      </th>
                      <th className="p-2">
                        <div className="font-semibold text-center">Zi de nastere</div>
                      </th>
                      <th className="p-2">
                        <div className="font-semibold text-center">Specialitatea</div>
                      </th>
                    </tr>
                  </thead>
                  <tbody className="text-sm font-medium divide-y divide-gray-100 dark:divide-gray-700/60">
                    {currentItems.sort((a, b) => a.user_name_surname.localeCompare(b.user_name_surname)).map((customer, index) => {
                      const filteredAdress = userinstData
                        .filter((i) => i.physician_id === customer.physician_id);

                      const isSelected = selectedInstitutionId === customer.physician_id;

                      return (
                        <React.Fragment key={customer.physician_id}>
                          <tr
                            role="button"
                            className={`${index % 2 === 0 ? "bg-gray-0 dark:bg-gray-800" : "bg-gray-100 dark:bg-gray-700"} hover:bg-gray-200 dark:hover:bg-gray-600`}
                          >
                            <td className="p-2 whitespace-nowrap" onClick={() => setSelecteduser1(customer)}>
                              <div className="text-left">{customer.user_name_surname}</div>
                            </td>
                            <td className="p-2 whitespace-nowrap" onClick={() => setSelecteduser1(customer)}>
                              <div className="text-center">{customer.email}</div>
                            </td>
                            <td className="p-2 whitespace-nowrap" onClick={() => setSelecteduser1(customer)}>
                              <div className="text-center">{customer.phone}</div>
                            </td>
                            <td className="p-2 whitespace-nowrap">
                              <div className="text-center">{customer.birth}</div>
                            </td>
                            <td className="p-2 whitespace-nowrap">
                              <div className="text-left">
                                {filteredAdress.length >= 1 ? (
                                  <button
                                    className="text-blue-500 underline"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setSelectedInstitutionId(isSelected ? null : customer.physician_id);
                                    }}
                                  >
                                    Vezi toate specialitățile ({filteredAdress.length})
                                  </button>
                                ) : (
                                  <span>Fara date</span>
                                )}
                              </div>
                            </td>
                          </tr>

                          {isSelected && (
                            <tr className="bg-gray-50 dark:bg-gray-800">
                              <td colSpan="7" className="p-2">
                                <table className="w-full border border-gray-300 dark:border-gray-600">
                                  <thead className="text-xs uppercase text-gray-500 dark:text-gray-500 bg-gray-100 dark:bg-gray-700 dark:bg-opacity-50 rounded-sm">
                                    <tr>
                                      <th className="p-2">
                                        <div className="font-semibold text-left">Specialitatea</div>
                                      </th>
                                      <th className="p-2">
                                        <div className="font-semibold text-left">Institutia</div>
                                      </th>
                                      <th className="p-2">
                                        <div className="font-semibold text-left">Adresa</div>
                                      </th>
                                      <th className="p-2">
                                        <div className="font-semibold text-left">Oras</div>
                                      </th>
                                      <th className="p-2">
                                        <div className="font-semibold text-left">Regiunea</div>
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {filteredAdress.map((item, idx) => {
                                      const matchdistrict = instcity
                                        .filter((i) => i.id === item.institution_in_adress_id)
                                        .map((i) => i.adress_id);

                                      const matchingCity1 = matchdistrict.length > 0
                                        ? city.find((i) => matchdistrict.includes(i.adress_id))
                                        : null;

                                      return (
                                        <tr key={idx} className="border border-gray-300 dark:border-gray-600">
                                          <td className="p-2 text-left">{item.spec}</td>
                                          <td className="p-2 text-left">{item.inst}</td>
                                          <td className="p-2 whitespace-nowrap">
                                            <div className="text-left">
                                              {matchingCity1 ? matchingCity1.description : "-"}
                                            </div>
                                          </td>
                                          <td className="p-2 whitespace-nowrap">
                                            <div className="text-left">
                                              {matchingCity1 ? matchingCity1.city_name : "-"}
                                            </div>
                                          </td>
                                          <td className="p-2 whitespace-nowrap">
                                            <div className="text-left">
                                              {matchingCity1 ? matchingCity1.district_name : "-"}
                                            </div>
                                          </td>
                                        </tr>
                                      )
                                    })}
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          )}
                        </React.Fragment>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              {uniqueUsers.length > 5 && (
                <>
                  <div className="flex justify-between items-center mb-4 mt-4">
                    <div className="text-sm text-gray-600 dark:text-gray-400">
                      Total: {uniqueUsers.length} doctori
                    </div>
                    <div className="flex items-center space-x-2">
                      <span className="text-sm text-gray-600 dark:text-gray-400">Arată:</span>
                      <select
                        className="border w-40 border-gray-300 dark:border-gray-600 rounded-md px-3 py-1.5 text-sm bg-white dark:bg-gray-700 dark:text-gray-200"
                        value={itemsPerPage}
                        onChange={(e) => setItemsPerPage(Number(e.target.value))}
                      >
                        <option value={5}>5 pe pagină</option>
                        <option value={10}>10 pe pagină</option>
                        <option value={15}>15 pe pagină</option>
                        <option value={uniqueUsers.length}>Toate</option>
                      </select>
                    </div>
                  </div>
                  <div className="flex justify-center mt-4">

                    <button
                      onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                      className="px-4 py-2 bg-gray-200 dark:bg-gray-700 text-sm font-medium rounded-l-md hover:bg-gray-300 dark:hover:bg-gray-600 disabled:opacity-50 dark:text-gray-100"
                      disabled={currentPage === 1}
                    >
                      Prev
                    </button>

                    {currentPage > 3 && (
                      <>
                        <button
                          onClick={() => setCurrentPage(1)}
                          className="px-4 py-2 text-sm font-medium bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600"
                        >
                          1
                        </button>
                        <span className="px-2">...</span>
                      </>
                    )}

                    {Array.from({ length: totalPages }, (_, index) => {
                      const page = index + 1;

                      if (page === currentPage ||
                        (page >= currentPage - 2 && page <= currentPage + 2)) {
                        return (
                          <button
                            key={page}
                            onClick={() => setCurrentPage(page)}
                            className={`px-4 py-2 text-sm font-medium ${currentPage === page
                              ? "bg-gray-500 text-white"
                              : "bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600  dark:text-gray-100"}`}
                          >
                            {page}
                          </button>
                        );
                      }
                      return null;
                    })}

                    {currentPage < totalPages - 2 && (
                      <>
                        <span className="px-2">...</span>
                        <button
                          onClick={() => setCurrentPage(totalPages)}
                          className="px-4 py-2 text-sm font-medium bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600  dark:text-gray-100"
                        >
                          {totalPages}
                        </button>
                      </>
                    )}

                    <button
                      onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                      className="px-4 py-2 bg-gray-200 dark:bg-gray-700 text-sm font-medium rounded-r-md hover:bg-gray-300 dark:hover:bg-gray-600 disabled:opacity-50  dark:text-gray-100"
                      disabled={currentPage === totalPages}
                    >
                      Next
                    </button>
                  </div></>
              )}
            </div>
          ) : (<h2 className="px-5 py-4 text-gray-600 dark:text-gray-400 ">Nu activeaza nici un doctor in institutia actuala</h2>
          )}
        </div>
      )}
    </div>
  );
}

export default DashboardCard20physicians;